function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 0a3 3 0 100 6 3 3 0 000-6zm11 3a3 3 0 11-6 0 3 3 0 016 0zm3.89 9.55l-1.44-2.89A3 3 0 0017.77 8h-4c.183.238.344.492.48.76l1.45 2.9a3 3 0 01.13 2.34H21a1 1 0 00.89-1.45zM9.76 8a3 3 0 012.69 1.66l1.44 2.89A1 1 0 0113 14H1a1 1 0 01-.89-1.45l1.44-2.89A3 3 0 014.24 8h5.52z"
});

var SvgGroupEqual = function SvgGroupEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10.181,
    viewBox: "0 0 22 14",
    fill: "#fff"
  }, props), _ref);
};

export default SvgGroupEqual;